import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import 'swiper/css/swiper.css'
import FeaturedPostsTitle from './components/FeaturedPostsTitle'
import FeaturedPosts from './components/FeaturedPosts'
import ProductCarousel from './components/ProductCarousel'

Vue.use(VueLazyload, {
  loading: '/wp-content/uploads/2020/07/placeholder-test1.png',
})
Vue.component('featured-posts-title', FeaturedPostsTitle)
Vue.component('featured-posts', FeaturedPosts)
Vue.component('product-carousel', ProductCarousel)

Vue.config.ignoredElements = ['ins']

new Vue({
	el: '#site-main',
})